import Vue from 'vue';
import Cookies from 'js-cookie'
import Toastify from 'toastify-js'
import "toastify-js/src/toastify.css"
const $ = window.jQuery;
new Vue({
    el: '#Cookies_banner_el',
    data() {
        return {
            showBanner: false,
            loading: false,
            showDetails: false,
            activeCookie: null,
            isMobile: false,
            hideBtn: true,
        }
    },
    watch: {
        showBanner(v) {
            this.handleActiveCheckboxes()
            // v ? document.body.style.overflow = 'hidden' : document.body.style.overflow = ''
        },
        showDetails(v) {
            if (v) this.showBanner = false
            this.handleActiveCheckboxes()
            let cookies = Cookies.get('phoenix')
            if (v) {
                setTimeout(() => {
                    // v ? document.body.style.overflow = 'hidden' : document.body.style.overflow = ''
                }, 70)
            } else {
                if (!cookies) {
                    this.showBanner = true
                    // setTimeout(() => {
                    //     document.body.style.overflow = 'hidden'
                    // }, 70)
                } else {
                    // setTimeout(() => {
                    //     document.body.style.overflow = ''
                    // }, 70)
                }
            }

        }
    },
    beforeMount() {
        this.checkCookies()
    },
    mounted() {
        if (window) {
            this.detectMobileMode()
            window.addEventListener("resize", (event) => {
                this.detectMobileMode(event)
            })
        }
        if (document) {
            if (document.getElementById('Cookies_banner')) {
                setTimeout(() => {
                    document.getElementById('Cookies_banner').classList.remove('hidden')
                }, 200)
            }
            if (document.getElementById('Cookies_banner--overflow')) {
                setTimeout(() => {
                    document.getElementById('Cookies_banner--overflow').classList.remove('hidden')
                }, 200)
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.detectMobileMode)
    },
    methods: {
        detectMobileMode(event) {
            let innerWidth
            if (event) {
                innerWidth = event.currentTarget.innerWidth
            } else {
                innerWidth = window.innerWidth
            }
            innerWidth < 1024 ? this.isMobile = true : this.isMobile = false
        },
        handleActiveCheckboxes() {
            let cookies = Cookies.get('phoenix')
            if (!cookies && !this.showDetails) {
                this.showBanner = true
                return false
            } else if (!cookies && this.showDetails) {
                this.showBanner = false
            }
            if (!cookies) return
            const cookieList = JSON.parse(cookies);
            for (const [key, value] of Object.entries(cookieList)) {
                let id = `${key}_cookie`
                let idExpanded = `${key}_cookie_expanded`
                if (document.getElementById(id) && document.getElementById(idExpanded)) {
                    document.getElementById(id).checked = false
                    document.getElementById(idExpanded).checked = false
                }
                if (value) {
                    if (document.getElementById(id) && document.getElementById(idExpanded)) {
                        document.getElementById(id).checked = true
                        document.getElementById(idExpanded).checked = true
                    }
                }
            }
        },
        closeModal() {
            let cookies = Cookies.get('phoenix')
            if (!cookies) {
                this.showDetails = false
                return
            }
            this.showBanner = false
            this.showDetails = false
            this.activeCookie = null
            this.loading = false

        },
        submit(checkAll) {
            Cookies.remove('phoenix', {path: '/'})
            this.loading = true
            const form = $('#CookiesForm')
            if (!form || !form.length) return false
            let $inputs
            if (checkAll === 'selected') {
                if (this.showDetails) {
                    $inputs = $('#CookiesFormExpanded :input[type=checkbox]');
                } else {
                    $inputs = $('#CookiesForm :input[type=checkbox]');
                }
            } else {
                $inputs = $('#CookiesForm :input[type=checkbox]');
            }
            if (!$inputs) return false
            var values = {};
            if ($inputs && $inputs.length) {
                if (checkAll !== 'selected') {
                    $inputs.each(function (index) {
                        if (checkAll) {
                            $(this).prop('checked', true)
                        } else if (!checkAll && index !== 0) {
                            $(this).prop('checked', false)
                        }
                        values[this.name] = $(this).is(":checked");
                    });
                } else {
                    $inputs.each(function () {
                        $(this).prop('checked', $(this).is(":checked"))
                        values[this.name] = $(this).is(":checked");
                    });
                }
            }
            if (Object.keys(values).length) {
                Cookies.set('phoenix', JSON.stringify(values), {expires: 180})
            } else {
                return false
            }
            setTimeout(() => {
                this.checkCookies()
            }, 100)
        },
        checkCookies() {
            let cookies = Cookies.get('phoenix')
            this.handleActiveCheckboxes()
            this.setCookiesScript(cookies)
        },
        setCookiesScript(cookies = null) {
            const $that = this
            if (!cookies) return false
            const cookie = JSON.parse(cookies);
            $.ajax({
                method: 'POST',
                url: ajax_object.ajaxurl,
                data: {
                    action: 'getCookieData',
                    nonce: ajax_object.nonce,
                    data: cookie
                },
                success: function (data) {
                    if (data) {
                        const reponse = JSON.parse(data)
                        if (reponse && reponse.success) {
                            const data = reponse.data
                            if (!data || !data.length) return false
                            data.forEach(el => {
                                if (el.cookies_header_section_code) {
                                    $('head').prepend(el.cookies_header_section_code)
                                }
                                if (el.cookies_body_section_code) {
                                    $('body').prepend(el.cookies_body_section_code)
                                }
                                if (el.cookies_footer_section_code) {
                                    $('footer').append(el.cookies_footer_section_code)
                                }
                            })
                        } else {
                            Toastify({
                                text: "Something went wrong applying cookies, please refreshe the page and try again.",
                                className: "error",
                                style: {
                                    // background: "linear-gradient(to right, #00b09b, #96c93d)",
                                }
                            }).showToast();
                            Cookies.remove('phoenix', {path: '/'})
                            $that.showBanner = true
                            $that.showDetails = false
                            $that.loading = false
                            return
                        }
                        $that.closeModal()
                    }
                },
                error: function (e) {
                    console.log(e)
                    $that.loading = false
                }
            })
        }
    }
})
